import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { OnboardingLayout } from '../Layout';
import { paths } from '@/routes/paths';

export function OnboardingFillLaterPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <OnboardingLayout back>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', gap: 8 }}>
        <h1 style={{ margin: 0 }}>{t('onboarding.fill_later.title')}</h1>
        <p style={{ color: 'var(--color-text-on-dark-muted)' }}>{t('onboarding.fill_later.body')}</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <Button block size="lg" variant="inverted" onClick={() => navigate(paths.onboardingFamilyEmpty)}>
          {t('onboarding.fill_later.fill_in')}
        </Button>
        <Button block size="lg" variant="ghost" onClick={() => navigate(paths.onboardingSubscribePitch)}>
          {t('onboarding.fill_later.fill_later')}
        </Button>
      </div>
    </OnboardingLayout>
  );
}
